App.controller('LifeWithPaymentsDetailsCtrl', ['$scope', '$stateParams', 'Configurator', '$timeout', '$state', 'profileService', 'lifeInsuranceWithPaymentsService', 'popUpService', '$filter', function ($scope, $stateParams, Configurator, $timeout, $state, profileService, lifeInsuranceWithPaymentsService, popUpService, $filter) {
    $scope.page = 'insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.life.list';
    $scope.$emit('link', $scope.link);

    // Determine if user is logged in;
    if (window.sessionStorage.getItem('userObject')) {
        $scope.userObject = angular.fromJson(window.sessionStorage.getItem('userObject'));
    }

    if (!$stateParams.declarationUuid) {
        $state.go('root.life.list', angular.extend($stateParams), {inherit: false});
    } else {
        lifeInsuranceWithPaymentsService.getDeclaration($stateParams.declarationUuid).then(
            function (success) {
                if (success.status === 200) {
                    $scope.data = success.data;

                    let names = [];
                    $scope.data.lifeInsurances.forEach(function (lifeInsurance) {
                        names.push(lifeInsurance.name)
                    });
                    $scope.data.benefit = {
                        names: names,
                    };

                     if (!$filter('unumDeclarationPersonaDetailsConsistency')($scope.userObject.person, $scope.data.person)) {
                        popUpService.showPopUp({content: 'Wprowadzone dane różnią się od tych w Koncie Użytkownika. Zachęcamy do aktualizacji danych również w systemie Xilium – wystarczy wejść w zakładkę Mój profil i wprowadzić aktualne dane.'});
                    }
                } else {
                    $state.go('root.life.list', angular.extend($stateParams), {inherit: false});
                }
            },
            function () {
                $state.go('root.life.list', angular.extend($stateParams), {inherit: false});
            }
        );
    }

    $scope.bankAccountNumber = null;
    profileService.getBankAccountNumber('LIFE_INSURANCE').then(function (success) {
        console.log('[lifeDetailsCtrl] [getBankAccountNumber]', success.data);
        if (success.data) {
            $scope.bankAccountNumber = success.data['accountNumber'];
        }
    });

    $scope.partnerAdditionalFields = ['birthplace', 'identifier'];
    if (Configurator.lifeInsuranceWithPayments.insurer === 'Unum') {
        $scope.assuredAdditionalFields = ['relationship'];
    }
}]);
